<template>
  <div>
    <section>
      <div class="header">
        <div class="headerContainer">
          <el-breadcrumb>
            <!-- 组织架构 -->
            <el-breadcrumb-item>
              {{ $t("message.organizationalStructure") }}</el-breadcrumb-item>
            <!-- 角色列表 -->
            <el-breadcrumb-item to="roleList">{{
              $t("message.theRoleList")
            }}</el-breadcrumb-item>
            <!-- 权限设置 -->
            <el-breadcrumb-item>{{
              $t("message.permissionSetting")
            }}</el-breadcrumb-item>
          </el-breadcrumb>
          <!-- 模板 -->
          <div class="select">
            <el-select v-model="val" placeholder="选择模板" filterable clearable @change="getTemplate">
              <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
            <el-button type="primary" @click="setRoleAuth" style="margin-left: 20px;">{{
              $t("message.save")
            }}</el-button>
          </div>
        </div>
      </div>
      <div class="footer">
        <div class="footerContainer">
          <div class="auth">
            <div class="menu item">
              <!--  菜单权限-->
              <div class="title">{{ $t("message.menuPermissions") }}</div>
              <div class="item-main" v-for="(item, index) in menu" :key="item.id">
                <!-- 一级 -->
                <div class="item-title">
                  <el-checkbox v-model="item.checked" @change="changeMenu">{{
                    item.name
                  }}</el-checkbox>
                </div>
                <!-- 二级 -->
                <div class="itmeChed" v-for="(items, indexs) in item.child_menus" :key="items.id">
                  <div class="foxbase">
                    <el-checkbox v-model="items.checked" :disabled="!item.checked" @change="allCancel(index, indexs)">{{
                      items.name }}</el-checkbox>
                  </div>
                  <!-- 三级 -->
                  <div class="three">
                    <el-checkbox v-model="itemss.checked" v-for="itemss in items.child_menus" :key="itemss.id"
                      @change="setAuthMenu" :disabled="!item.checked || !items.checked">{{ itemss.name }}
                      <!-- {{ itemss.id }} -->
                    </el-checkbox>
                  </div>
                </div>
              </div>
            </div>
            <div class="page item">
              <!-- 操作权限 -->
              <div class="title">
                {{ $t("message.operatingAuthorization") }}
              </div>
              <div class="page-item-box" v-for="(item, index) in page" :key="index">
                <div class="item-main" v-if="checkAll.indexOf(item.parent_id) != -1">
                  <div class="item-title">{{ item.name }}</div>
                  <div class="itmeChed">
                    <el-checkbox v-model="items.checked" v-for="items in item.child_buttons" :key="items.id">{{
                      items.name
                    }}
                      {{ items.id }}
                    </el-checkbox>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="btn">
            <!-- 保存 -->
            <!-- <el-button type="primary" @click="daochu">导出</el-button> -->
            <!-- 保存 -->
            <el-button type="primary" @click="setRoleAuth">{{
              $t("message.save")
            }}</el-button>
            <!-- 全选 -->
            <el-button type="primary" @click="allChecked">模块{{ $t("message.allChecked") }}</el-button>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  data() {
    return {
      val: '',
      options: [],
      menu: [],
      page: [],
      checked: false,
      checkAll: [],
      detals: {},
    };
  },
  created() {
    this.$api.roleApi.roleList({ pageSize: 10000, page: 1 }).then((res) => {
      this.options = res.data.data;
    });
    this.allAuth();
  },
  methods: {
    // 获取权限，并添加每项勾选
    allAuth() {
      let roleAuth =
        this.$store.state.roleAuth != undefined
          ? this.$store.state.roleAuth
          : [];
      this.$api.roleApi.allAuth().then((res) => {
        this.setAllAuth(roleAuth, res.data)
      });
    },
    //预选权限
    setAllAuth(roleAuth, data) {
      data.menu.forEach((item) => {
        let isAuth = roleAuth.find((auth) => auth.id == item.id);
        if (isAuth) {
          item.checked = true;
        } else {
          item.checked = false;
        }
        item.child_menus.forEach((items) => {
          let isAuths = roleAuth.find((auths) => auths.id == items.id);
          if (isAuths) {
            items.checked = true;
          } else {
            items.checked = false;
          }
          items.child_menus.forEach((itemss) => {
            let isAuthss = roleAuth.find((auths) => auths.id == itemss.id);
            if (isAuthss) {
              itemss.checked = true;
              this.checkAll.push(itemss.id);
            } else {
              itemss.checked = false;
            }
          });
        });
      });
      data.page.forEach((item) => {
        item.child_buttons.forEach((items) => {
          let isAuths = roleAuth.find((auths) => auths.id == items.id);
          isAuths ? (items.checked = true) : (items.checked = false);
        });
      });
      this.menu = data.menu;
      this.page = data.page;
      this.detals = data
    },
    // 选择菜单显示改页面权限
    setAuthMenu() {
      this.checkAll = [];
      this.menu.forEach((item) => {
        item.child_menus.forEach((items) => {
          items.child_menus.forEach((itemss) => {
            if (itemss.checked) {
              this.checkAll.push(itemss.id);
            }
          });
        });
      });
    },
    // 不选菜单 关闭底下全部权限
    changeMenu() {
      this.menu.forEach((item) => {
        if (!item.checked) {
          item.child_menus.forEach((items) => {
            items.checked = false;
            items.child_menus.forEach((itemss) => {
              itemss.checked = false;
            });
          });
        }
      });
      this.setAuthMenu();
    },
    // 二级菜单全取消
    allCancel(index, indexs) {
      this.menu[index].child_menus[indexs].child_menus.forEach((item) => {
        item.checked = false;
      });
    },
    //已选一级菜单，自动帮选2，3级菜单
    allChecked() {
      this.menu.forEach((item) => {
        if (item.checked) {
          item.child_menus.forEach((items) => {
            items.checked = true;
            items.child_menus.forEach((itemss) => {
              itemss.checked = true;
              // 页面权限全选
              this.page.forEach((page) => {
                page.child_buttons.forEach((pages) => {
                  pages.checked = true
                });
              });
            });
          });
        }
      });
    },
    // 保存
    setRoleAuth() {
      let datas = {
        role_id: this.$route.query.id,
        auth: [],
      };
      this.menu.forEach((item) => {
        if (item.checked) {
          datas.auth.push(item.id);
          item.child_menus.forEach((items) => {
            if (items.checked) {
              datas.auth.push(items.id);
            }
            items.child_menus.forEach((itemss) => {
              if (itemss.checked) {
                datas.auth.push(itemss.id);
              }
            });
          });
        }
      });
      this.page.forEach((item) => {
        item.child_buttons.forEach((items) => {
          if (items.checked) {
            datas.auth.push(items.id);
          }
        });
      });
      console.log(datas);
      this.$api.roleApi.setRoleAuth(datas).then((res) => {
        this.$message.success(res.msg);
        // this.allAuth();
      });
    },
    //导出
    daochu() {
      let list = []
      let i = 0
      this.page.forEach(item => {
        item.child_buttons.forEach(items => {
          items.index = i
          i++
          list.push(items)
        })
      })
      this.handleExportExcel(list)
    },
    // excel导出
    handleExportExcel(list) {
      require.ensure([], () => {
        const { export_json_to_excel } = require('@/utlis/Export2Excel')
        const tHeader = ['NO', '权限名称', '权限ID']
        const filterVal = ['index', 'name', 'id']
        const data = this.formatJson(filterVal, list)
        export_json_to_excel(tHeader, data, '权限列表')
      })
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]))
    },
    //选择模板选中权限
    getTemplate(e) {
      let roleAuth = this.options.find(item => item.id == e).auth
      this.setAllAuth(roleAuth, this.detals)
      // console.log(e);
    },
  },
};
</script>
<style lang='scss' scoped>
/deep/.el-checkbox__inner {
  transform: scale(1.5);
}

section {
  background-color: #f6f6f6;

  .header {
    padding: 20px;

    .headerContainer {
      padding: 20px;
      background-color: #fff;
      position: relative;

      .select {
        position: absolute;
        top: 10px;
        right: 20px;
      }
    }
  }

  .footer {
    padding: 0 20px 20px;

    .footerContainer {
      padding: 20px;
      background-color: #fff;
    }
  }
}

.name {
  margin: 0 0 20px;

  p {
    margin-bottom: 20px;
  }

  span {
    margin-right: 50px;
    color: #036eb8;
    cursor: pointer;
  }
}

.auth {
  display: flex;

  .item-main {
    margin-bottom: 50px;
  }

  .item {
    flex: 1;
    border: 1px solid #ccc;
    padding: 20px;
    border-radius: 20px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

    .item-title {
      margin: 20px 20px 20px 0;
    }

    .itmeChed {
      margin-left: 20px;

      .el-checkbox {
        margin-bottom: 10px;
      }

      .foxbase {
        .el-checkbox {
          margin: 0 0 15px 0px;
        }
      }

      .three {
        margin-left: 25px;
        margin-bottom: 10px;
      }
    }
  }

  .menu {
    margin-right: 30px;
  }
}

.btn {
  text-align: center;
  margin: 50px 0 0;
}
</style>